/**
 * Labstep
 *
 * @module components/Protocol/Action/Menu
 * @desc Action Menu for protocol
 */

import EntityActionPrint from 'labstep-web/components/Entity/Action/Print';
import ProtocolActionDuplicate from 'labstep-web/components/Protocol/Action/Duplicate';
import RestoreAction from 'labstep-web/components/Protocol/Action/Restore';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { IProtocolActionMenuProps } from './types';

export const ProtocolActionMenu: React.FC<
  IProtocolActionMenuProps
> = ({ protocol, actions = [] }) => (
  <ActionMenu type="icon">
    {actions.includes('duplicate') && (
      <ProtocolActionDuplicate protocol={protocol} />
    )}
    {actions.includes('restore') && (
      <RestoreAction protocol={protocol} />
    )}
    {actions.includes('print') && (
      <EntityActionPrint entity={protocol} />
    )}
  </ActionMenu>
);

ProtocolActionMenu.defaultProps = {
  actions: [],
};
